import React, { useState, useEffect, Component } from "react";
import { changeIndexToNepali, colorScale } from "../../utils";
import Api from "../../services/api";
import localMapJson from "../../assets/geoJson/province.json";
import { Line } from "rc-progress";
import GradientLabel from "../../components/GradientLabel";
import { ListGroup, ListGroupItem, Row, Col, Button } from "reactstrap";
import {
  Legend,
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
  ResponsiveContainer,
} from "recharts";
import ProgressBar from "../../components/ProgressBar";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import "./style.css";
import DetailTable from "./../../components/CustomTable/DetailTable";
import BarGraph from "../../components/BarChart";
import StageTable from "../../components/CustomTable/StageTable";
import * as modalAction from "../../actions/modalAction";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { color } from "d3";
import MinistryDetailTable from "../../components/CustomTable/MinistryDetailTable";
import NonMinistryAccordion from "../../components/accordion/nonministry";

let baseUrl =
  process.env.REACT_APP_API_BASE_URL ||
  "https://pfra.gov.np/admin/api";

function Detail({ onDocumentsShow }) {
  const [data, setData] = useState([]);
  const [rank, setRank] = useState([]);
  const [tableData, setTable] = useState([]);
  const [scoreData, setScoreData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Author Tezz Bhandari
  // initial Fiscal Year State
  const setCurrentFiscalYearId = () => {
    let localData;

    if (localStorage.getItem("user")) {
      localData = JSON.parse(localStorage.getItem("user"))
    }
    return localData
        ? localData.user.fiscal_year_id
        : localStorage.getItem("fiscalYear")
  }

  const [currentFiscalYear, setCurrentFiscalYear] = useState(setCurrentFiscalYearId());
  const [activeTab, setActiveTab] = useState(0);
  const [ministryCat, setMinistryCat] = useState([]);
  const [user, setUser] = useState(
    localStorage.getItem("user") &&
    JSON.parse(localStorage.getItem("user")).user
  );


  let search = window.location.search;
  let geoJson = localMapJson.response.find((province) => {
    return +sessionStorage.getItem("provinceId") === province.id;
  });

  // const _getCategories = async () => {
  //   let response = await Api.getQuestions(
  //     user && user.fiscal_year_id
  //       ? user && user.fiscal_year_id
  //       : currentFiscalYear,
  //     sessionStorage.getItem("provinceId"),
  //     newS
  //   );
  //   setTable(response.response.questions);
  // };
  const getMinistryCategories = async () => {
    let response = await Api.getMinistryQuestions(
      user && user.fiscal_year_id
        ? user && user.fiscal_year_id
        : currentFiscalYear,

      sessionStorage.getItem("provinceId"),
      sessionStorage.getItem("m_id")
    );
    setMinistryCat(response.response.questions);
  };
  const getData = async () => {
    // setIsLoading(true);
    let checkin = [];
    await fetch(
      `${baseUrl}/local?fiscal_year_id=${currentFiscalYear}&province_id=${sessionStorage.getItem(
        "provinceId"
      )}&ministry_id=${sessionStorage.getItem("m_id")}`,
      {
        method: "Get",
      }
    )
      .then((response) => response.json())
      .then((json) => {
        if (json.code === 200) {
          if (json.response.stages) {
            setScoreData(json.response.stages);
          }
          setData(json.response);
          if (json && json.response && json.response.ranking_indexes) {
            checkin.push({
              ...json.response.ranking_indexes.ministry_level,
              name: `(Ministry Level) ${json.response.ranking_indexes
                .ministry_level &&
                json.response.ranking_indexes.ministry_level.name}`,
            });
            checkin.push({
              ...json.response.ranking_indexes.province_level,
              name: `(Province Leader) ${json.response.ranking_indexes
                .province_level &&
                json.response.ranking_indexes.province_level.name}`,
            });
            setRank(checkin);
          }
        }
      });
    setIsLoading(false);
  };

  const getCat = () => {
    fetch(`${baseUrl}/categories`, {
      method: "Get",
    })
      .then((response) => response.json())
      .then((json) => {
        // setCat(json.response);
        // console.log(json.response);
      });
  };

  

  const setFiscalYearId = async () => {
    let localData;
    if (localStorage.getItem("user")) {
      localData = await JSON.parse(localStorage.getItem("user"));
    }
    setCurrentFiscalYear(
      localData
        ? localData.user.fiscal_year_id
        : localStorage.getItem("fiscalYear")
    );
    // console.log(
    //   "my data",
    //   localStorage.getItem("fiscalYear"),
    //   currentFiscalYear
    // );
  };

  useEffect(() => {
    setFiscalYearId();
    getMinistryCategories();
    // getCat();
  }, [window.location.search]);

  useEffect(() => {
    if (currentFiscalYear) {
      getData();
      // _getCategories();
    }
  }, [window.location.search, currentFiscalYear]);

  const cars = new Array(data.subCategories);
  let check = cars.toString();
  var check2 = check.split(",");
  // console.warn(data)

  if (isLoading) {
    return <div className="mt-4">Loading...</div>;
  }

  const _openDocumentModal = () => {
    onDocumentsShow({
      gnid: sessionStorage.getItem("m_id"),
      modalType: "view",
    });
  };

  class CustomizedLabel extends Component {
    render() {
      const { x, y, fill, value } = this.props;
      return (
        <text
          x={x}
          y={y}
          dy={-5}
          dx={20}
          fontSize="16"
          fontFamily="sans-serif"
          fill={"#046204"}
          textAnchor="right"
        >
          {value}
        </text>
      );
    }
  }

  return (
    <>
      {data.length < 1 ? (
        <>
          <div className="header">
            <h1 className="heading">{geoJson.name}</h1>{" "}
            {/*TODO show , district name from map data*/}
          </div>
          <div>फारम सार्वजनिक भएको छैन।</div>
        </>
      ) : (
        <div>

          <div className="card-layout  d-flex flex-wrap justify-content-between">
            <div className=" col-12 col-sm-6 col-md-4 col-xl-1 d-flex my-2">
              {/* <div
                className="d-flex align-items-center"
                style={{ marginRight: "15px" }}
              >
                <img
                  src={require(`../../assets/images/province.svg`)}
                  alt="icons"
                  className="ms-0 icon-image"
                />
              </div> */}

              <div className="d-flex flex-column">
                <div className="d-flex justify-content-center">
                  <img
                    src={require(`../../assets/images/province.svg`)}
                    alt="icons"
                    className="ms-0 icon-image"
                  />
                </div>

                {/* <h5 style={{ color: colorScale(data.score) }}>प्रदेश:</h5>{" "} */}

                <p className="mt-2">{data.province}</p>
              </div>
            </div>
            <div className=" col-12 col-sm-6 col-md-4 col-xl-2 d-flex my-2">
              {/* <div
                className="d-flex align-items-center"
                style={{ marginRight: "15px" }}
              >
                <img
                  src={require(`../../assets/images/district.svg`)}
                  alt="icons"
                  className="ms-0 icon-image"
                />
              </div> */}
              <div className="d-flex flex-column">
                <div className="d-flex justify-content-center">
                  <img
                    src={require(`../../assets/images/district.svg`)}
                    alt="icons"
                    className="ms-0 icon-image"
                  />
                </div>

                {/* <h5 style={{ color: colorScale(data.score) }}>मन्त्रालय:</h5>{" "} */}
                <span className="mt-2 text-center">{data.name}</span>
              </div>
            </div>
            <div className=" col-12 col-sm-6 col-md-4 col-xl-2 d-flex my-2">
              {/* <div
                className="d-flex align-items-center"
                style={{ marginRight: "15px" }}
              >
                <img
                  src={require(`../../assets/images/email.svg`)}
                  alt="icons"
                  className="ms-0"
                  style={{ height: "35px" }}
                />
              </div> */}
              <div className="d-flex flex-column">
                <div className="d-flex justify-content-center">
                  <img
                    src={require(`../../assets/images/email.svg`)}
                    alt="icons"
                    className="ms-0"
                    style={{ height: "35px" }}
                  />
                </div>
                {/* <h5 style={{ color: colorScale(data.score) }}>ईमेल:</h5>{" "} */}
                <div className="mt-2">
                  <a href={`mailto:${data.email}`}>
                    <span className="mt-2">{data.email}</span>
                  </a>
                </div>
              </div>
            </div>
            <div className=" col-12 col-sm-6 col-md-4 col-xl-2 d-flex my-2">
              {/* <div
                className="d-flex align-items-center"
                style={{ marginRight: "15px" }}
              >
                <img
                  src={require(`../../assets/images/web.svg`)}
                  alt="icons"
                  className="ms-0 "
                  style={{ height: "35px" }}
                />
              </div> */}
              <div>
                <div className="d-flex justify-content-center">
                  <img
                    src={require(`../../assets/images/web.svg`)}
                    alt="icons"
                    className="ms-0 "
                    style={{ height: "35px" }}
                  />
                </div>
                {/* <h5 style={{ color: colorScale(data.score) }}>वेबसाइट:</h5>{" "} */}
                <div className="mt-2">
                  <a href={`https://${data.website}`}>
                    <span>{data.website}</span>
                  </a>
                </div>
              </div>
            </div>
            <div className=" col-12 col-sm-6 col-md-4 col-xl-2 d-flex my-2">
              {/* <div
                className="d-flex align-items-center"
                style={{ marginRight: "15px" }}
              >
                <img
                  src={require(`../../assets/images/score.svg`)}
                  alt="icons"
                  className="ms-0 icon-image"
                  style={{ backgroundSize: "cover" }}
                />
              </div> */}
              <div>
                <div>
                  <div sm="10" className="d-flex justify-content-center">
                    <img
                      src={require(`../../assets/images/score.svg`)}
                      alt="icons"
                      className="ms-0 icon-image"
                      style={{ backgroundSize: "cover" }}
                    />
                    <p className="text-center ml-1 h5 mt-2">
                      (
                      {changeIndexToNepali(
                        data.ranking_indexes.ministry_level.score
                      )}
                      )
                    </p>
                  </div>
                  <div
                    sm="2"
                    style={{ color: colorScale(data.ministry_score) }}
                  >
                    <h5>मन्त्रालयगत समग्र स्थिति</h5>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className=" col-12 col-sm-6 col-md-4 col-xl-2 d-flex my-2">
              <div
                className="d-flex align-items-center"
                style={{ marginRight: "15px" }}
              >
                <img
                  src={require(`../../assets/images/score.svg`)}
                  alt="icons"
                  className="ms-0 icon-image"
                  style={{ backgroundSize: "cover" }}
                />
              </div>
              <div>
                <div>
                  <div sm="10" className="d-flex justify-content-center">
                    <img
                      src={require(`../../assets/images/score.svg`)}
                      alt="icons"
                      className="ms-0 icon-image"
                      style={{ backgroundSize: "cover" }}
                    />
                    <p className="text-center ml-1 mt-2 h5">
                      ({changeIndexToNepali(data.province_score)})
                    </p>
                  </div>
                  <div
                    sm="2"
                    style={{ color: colorScale(data.province_score) }}
                  >
                    <h5>एकीकृत लेखाजोखा स्थीति</h5>
                  </div>
                </div>
              </div>
            </div> */}
          </div>

          <div className="indicator-section d-flex justify-content-end m-3">
            <div className="d-flex flex-column">
              <span style={{ textAlign: "center" }}>
                सूचक स्थिति
              </span>
              <GradientLabel />
            </div>
          </div>

          <div className="">
            <Row>
              <Col sm="4">
                <div className="cat-list card-layout h-100">
                  <h3 className="sub-heading">
                    {" "}
                    मन्त्रालयगत वित्तीय सुशासन लेखाजोखा मूल्याङ्क
                  </h3>
                  <div className="main-list">
                    <span className="dash-cat-name-title"></span>
                    {/* <span className='dash-cat-rank-title'>बरीयतक्रम</span> */}
                    <span className="dash-cat-score-title">स्कोर प्रतिशत</span>
                  </div>
                  {ministryCat.map((item, catIndex) => {
                    const isImage =
                      item.image.match(/\.(jpeg|jpg|gif|png)$/) !== null;

                    return (
                      <div className="main-list">
                        <span className="dash-cat-name">
                          <img
                            src={
                              isImage
                                ? item.image
                                : require(`../../assets/images/${catIndex +
                                  1}.svg`)
                            }
                            className="cat-icon"
                            alt="cat-icon"
                          />
                          {item.name}
                        </span>
                        {/* <span className='dash-cat-rank'>{changeIndexToNepali(category.rank)}</span> */}
                        <ProgressBar
                          bgcolor={colorScale(item.marks_percentage)}
                          progress={item.marks_percentage}
                          height={10}
                        />
                      </div>
                    );
                  })}
                </div>
              </Col>
              <Col sm="8">
                <div className="card-layout">
                  <h3 className="sub-heading text-center m-0">
                    मन्त्रालयगत वित्तीय सुशासन लेखाजोखा मूल्याङ्क
                  </h3>
                  <RadarChart
                    outerRadius={150}
                    width={600}
                    height={400}
                    data={ministryCat}
                  >
                    <PolarGrid />
                    <PolarAngleAxis dataKey="name" />
                    <PolarRadiusAxis angle={90} domain={[0, 100]} />
                    <Radar
                      name="पूर्णांङ्क"
                      dataKey="total_percentage"
                      stroke="#82ca9d"
                      fill="transparent"
                      fillOpacity={0.6}
                      strokeWidth="3"
                    />
                    <Radar
                      name="प्राप्ताङ्क"
                      dataKey="marks_percentage"
                      stroke="#8884d8"
                      fill="#8884D8"
                      fillOpacity={0.6}
                    />

                    <Legend />
                  </RadarChart>
                </div>
              </Col>
            </Row>
          </div>

          <div className="d-flex my-4">
            <div className="col-4  mr-4 p-0">
              <Nav
                vertical
                style={{ border: "none", margin: "none" }}
                className="bg-white pr-1 rounded shadow-sm"
              >
                <p className="sub-heading mx-3 mt-3">
                  मूल्याङ्कन विषयक्षेत्रहरु
                </p>
                {ministryCat &&
                  ministryCat.map((tabData, index) => (
                    <NavItem
                      key={index}
                      style={{ width: "100%", display: "flex" }}
                      onClick={() => {
                        setActiveTab(index);
                      }}
                    >
                      <NavLink
                        className={`${activeTab === index
                          ? "nav-link-purple-borde px-4"
                          : "nav-link-ordinar px-3"
                          }`}
                      >
                        {tabData && tabData.name}
                      </NavLink>
                      {activeTab === index && <div className="arrow-right" />}
                    </NavItem>
                  ))}
              </Nav>
            </div>
            <div className="col ml-2">
              <TabContent activeTab={activeTab}>
                {ministryCat &&
                  ministryCat.map((tabData, index) => (
                    <TabPane key={index} tabId={index}>
                      {console.log("tabData", tabData)}
                      <div className="d-flex align-items-center">
                        <div className="d-flex flex-wrap justify-content-around col-8 bg-white rounded shadow-sm p-3">
                          <ResponsiveContainer width="100%" height={325}>
                            <BarChart data={tabData.subCategories}>
                              <CartesianGrid strokeDasharray="3 3" />
                              <XAxis dataKey="name" />
                              <YAxis
                                // domain={[0, 30]}
                                domain={[0, "dataMax + 10"]}
                              />
                              <Tooltip position={{ x: 0, y: 0 }} />
                              <Legend />

                              <Bar
                                dataKey="total_marks"
                                fill="#82ca9d"
                                name="पूर्णांङ्क"
                                label={<CustomizedLabel />}
                              />
                              <Bar
                                dataKey="marks"
                                fill="#8884d8"
                                name="प्राप्ताङ्क"
                                label={<CustomizedLabel />}
                              />
                            </BarChart>
                          </ResponsiveContainer>
                        </div>
                        <div
                          className="col-4 pt-4 ml-3 bg-white rounded shadow-sm align-self-center"
                          style={{ height: "350px" }}
                        >
                          <p
                            className="text-center h4"
                            style={{
                              textDecoration: "underline",
                              color: "#2571BB",
                            }}
                          >
                            अंकतालिका
                          </p>
                          <div
                            className=" card shadow-sm p-2 col-12 d-flex bg-light"
                            style={{ height: "100px" }}
                          >
                            <p className="text-success h5 text-center">
                              कुल प्राप्ताङ्क
                            </p>
                            <p
                              className="text-center h4"
                              style={{ color: "#FF7D00" }}
                            >
                              {changeIndexToNepali(tabData.obtained_marks)}
                            </p>
                          </div>

                          <div
                            className="card shadow-sm p-2 col-12 d-flex bg-light "
                            style={{ height: "100px" }}
                          >
                            <p className="text-success h5 text-center">
                              कुल पूर्णांङ्क
                            </p>
                            <p
                              className="text-center h4"
                              style={{ color: "#FF7D00" }}
                            >
                              {changeIndexToNepali(tabData.total_marks)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </TabPane>
                  ))}
              </TabContent>
            </div>
          </div>
          <div className="content">
            {/* <div className="bar-chart chart-section">
              <Row>
                <Col sm="12">
                  <div className="bar-chart">
                    <Row>
                      <Col sm="12">
                        <div className="card-layout bar-graph">
                          <Row>
                            <Col sm="12">
                              <h1 className="sub-heading">
                                PFRA Ranking Index
                              </h1>
                            </Col>
                          </Row>
                          <BarGraph data={rank} />
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div> */}
            <div className="mt-4">
              <Row>
                <Col sm="12">
                  <StageTable
                    comments={scoreData}
                    title="स्कोर तालिका"
                    isLoading={isLoading}
                  />
                </Col>
              </Row>
            </div>
            <div style={{ marginTop: "30px" }}>
              <NonMinistryAccordion
                categories={ministryCat}
                ministryLevel={true}
                ministry_id={sessionStorage.getItem("m_id")}
              />
            </div>
            {/* <div className="chart-section">
              <div className="d-flex justify-content-end mb-3">
                <Button
                  onClick={() => _openDocumentModal()}
                  className="btn btn-info"
                >
                  कागजातहरु हेर्नुहोस
                </Button>
              </div>
              <DetailTable
                comments={tableData}
                title={"एकीकृत लेखाजोखा तालिका"}
              />
            </div> */}

            <div className="chart-section">
              {/* <div className="d-flex justify-content-end mb-3">
                <Button
                  onClick={() => _openDocumentModal()}
                  className="btn btn-info"
                >
                  कागजातहरु हेर्नुहोस
                </Button>
              </div> */}
              {/* <MinistryDetailTable
                comments={ministryCat}
                title={"मन्त्रालयगत वित्तीय सुशासन लेखाजोखा तालिका"}
              /> */}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

const mapDispatchToProps = (dispatch) => ({
  onDocumentsShow: (modalProps) => {
    dispatch(
      modalAction.processModal(
        modalAction.SHOW_MODAL,
        modalAction.ModalTypes.SHOW_DOCUMENT,
        modalProps
      )
    );
  },
});

const enhance = compose(withRouter, connect(null, mapDispatchToProps));

export default enhance(Detail);
